import { Input, KeyCode } from "../../../lib/Input";
import Ability from "../../Ability";
import Player from "../../Player";

export default class AfterBurnerDash extends Ability {

    constructor(player: Player) {
        super(player, {
            cooldown: 10,
            duration: 0,
            energyCost: 20,
            icon: 0,
            trigger: KeyCode.Digit1,
            triggerType: Input.GetKeyDown,
            info: `Afterburner Dash (20s cooldown) - Gain a burst of speed towards your mouse`
        })
    }

    onUse(): void {
        const force = 300;
        const vector = this.player.engine.mouseWorldPosition.sub(this.player.transform.position).normalized;

        this.player.velocity = vector.scale(force);
    }

}